<template>
  <div>
    <el-dialog
      :title="isDisabled ? '分集详情' : formData.id ? '编辑分集' : '新增分集'"
      :visible.sync="value"
      append-to-body
      width="1200px"
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <el-form
        :model="formData"
        :disabled="isDisabled"
        :rules="rules"
        ref="formData"
        label-width="100px"
      >
        <div
          style="background-color: #f6f6f6; padding: 25px; border-radius: 10px"
        >
          <!-- 第一行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <span style="display: inline-block; width: 100px"
                >乐播分集 ID：</span
              >
              {{ formData.id || '--' }}</el-col
            >
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <el-form-item label="分集序号：" prop="num">
                <el-input
                  type="number"
                  placeholder="请输入分集序号"
                  v-model="formData.num"
                  :min="0"
                  @input="
                    () => {
                      if (formData.num !== '') {
                        const pattern = /^[1-9]\d*$/
                        if (!pattern.test(formData.num)) {
                          formData.num = ''
                        }
                      }
                    }
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第二行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item label="分集名称：" prop="name">
                <el-input
                  v-model="formData.name"
                  placeholder="请输入分集名称"
                  :maxlength="99"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <el-form-item label="分集描述：" prop="aword">
                <el-input
                  v-model="formData.aword"
                  placeholder="请输入分集描述"
                  :maxlength="999"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第三行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item label="横图：" prop="horizontalImgLarge">
                <el-upload
                  class="avatar-uploader"
                  style="display: flex; justify-content: center; width: 330px"
                  :action="actionUrl"
                  :show-file-list="false"
                  :on-success="
                    (res) => {
                      handleAvatarSuccess(res, 'horizontalImgLarge')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="formData.horizontalImgLarge"
                    :src="formData.horizontalImgLarge"
                    style="width: 100%"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="11">
              <el-form-item label="竖图：" prop="verticalImgLarge">
                <el-upload
                  class="avatar-uploader"
                  :show-file-list="false"
                  :action="actionUrl"
                  :on-success="
                    (res) => {
                      handleAvatarSuccess(res, 'verticalImgLarge')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="formData.verticalImgLarge"
                    :src="formData.verticalImgLarge"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第四行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item label="时长：" prop="duration">
                <el-input
                  type="number"
                  v-model="formData.duration"
                  :min="0"
                  placeholder="请输入时长"
                  @input="
                    () => {
                      if (formData.duration !== '') {
                        const pattern = /^[1-9]\d*$/
                        if (!pattern.test(formData.duration)) {
                          formData.duration = ''
                        }
                      }
                    }
                  "
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2"> </el-col>
            <el-col :span="11">
              <el-form-item label="试看时长：" prop="trialDuration">
                <el-input
                  v-model="formData.trialDuration"
                  @input="
                    () => {
                      if (formData.trialDuration !== '') {
                        const pattern = /^[1-9]\d*$/
                        if (!pattern.test(formData.trialDuration)) {
                          formData.trialDuration = ''
                        }
                      }
                    }
                  "
                  placeholder="请输入试看时长"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第五行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item label="是否解锁：" prop="feeMode">
                <el-radio-group v-model="formData.feeMode">
                  <el-radio :label="2">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2"> </el-col>
            <el-col :span="11">
              <el-form-item label="视频样式：" prop="direction">
                <el-radio-group v-model="formData.direction">
                  <el-radio :label="1">横视频</el-radio>
                  <el-radio :label="2">竖视频</el-radio>
                </el-radio-group>
              </el-form-item></el-col
            >
          </el-row>
          <!-- 第六行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item
                v-loading="loading"
                label="播放介质："
                prop="playUrl"
              >
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <el-button
                    v-if="!isDisabled"
                    type="mini"
                    @click="choiceMedium"
                    >选择介质</el-button
                  >
                  <span v-if="selectedMedium.name"
                    >{{
                      (selectedMedium.name + '.' + selectedMedium.fileFormat)
                        | totoLowerCase()
                    }}
                  </span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="2"> </el-col>
            <el-col :span="11">
              <el-form-item label="二维码地址：" prop="qrCode">
                <el-input
                  v-model="formData.qrCode"
                  placeholder="请输入二维码地址"
                  :maxlength="999"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第七行 -->
          <el-row style="margin: 0 0 20px 50px">
            <el-col :span="11">
              <el-form-item
                v-loading="loading"
                label="播放链接："
                prop="playUrl"
              >
                <el-input
                  v-model="formData.playUrl"
                  placeholder="请输入播放链接"
                  :maxlength="999"
                  v-if="!isDisabled"
                  @blur="analysisDuration"
                ></el-input>
                <div v-else>
                  {{ formData.playUrl }}
                  <span
                    style="color: #2140ef; cursor: pointer; padding: 0 10px"
                    @click="handleShowImage(formData.playUrl, 'video')"
                    >预览</span
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 第七行 -->
        <el-row style="margin: 0 0 0 50px; padding: 25px 25px 0">
          <el-col :span="11">
            <el-form-item label="播放介质：" prop="status">
              <el-radio-group v-model="formData.status">
                <el-radio :label="1">上线</el-radio>
                <el-radio :label="0">下线</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <div v-if="isDisabled" style="text-align: right">
              <span
                style="color: #2140ef; cursor: pointer; padding: 0 10px"
                @click="innerVisible = true"
                >三方分集信息</span
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span v-if="!isDisabled" slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button @click="mediaEpisodeSave" type="primary">确 定</el-button>
      </span>

      <el-dialog
        width="1000px"
        title="三方分集信息"
        v-if="innerVisible"
        :visible.sync="innerVisible"
        :modal-append-to-body="false"
        :before-close="
          (done) => {
            innerVisible = false
            done()
          }
        "
        append-to-body
      >
        <el-row
          style="margin: 0 0 20px 50px"
          v-if="formData.episodePartnerData"
        >
          <el-col :span="12">
            <span style="display: inline-block; width: 130px"
              >三方分集 ID：</span
            >
            {{
              formData.episodePartnerData
                ? formData.episodePartnerData.partnerEpisodeId || '--'
                : '--'
            }}</el-col
          >

          <el-col :span="12">
            <span style="display: inline-block; width: 130px"
              >三方分集状态：</span
            >
            {{
              formData.episodePartnerData
                ? { 0: '关', 1: '开' }[
                    formData.episodePartnerData.partnerEpisodeStatus
                  ] || '--'
                : '--'
            }}</el-col
          >
        </el-row>

        <el-row
          style="margin: 0 0 20px 50px"
          v-if="formData.episodePartnerData"
        >
          <el-col :span="12">
            <span style="display: inline-block; width: 130px"
              >版权商分集 ID：</span
            >
            {{
              formData.episodePartnerData
                ? formData.episodePartnerData.copyrightEpisodeId || '--'
                : '--'
            }}</el-col
          >

          <el-col :span="12">
            <span style="display: inline-block; width: 130px"
              >版权商分集编号：：</span
            >
            {{
              formData.episodePartnerData
                ? formData.episodePartnerData.copyrightEpisodeCode || '--'
                : '--'
            }}</el-col
          >
        </el-row>
      </el-dialog>
    </el-dialog>
    <MediumDialog ref="medium" @select="mediumSelect"></MediumDialog>
  </div>
</template>

<script>
import {
  mediaEpisodeApi,
  analysisDurationApi,
  mediaEpisodeEditApi
} from '@/api/mediaManage/mediaContentManage.js'
import { number } from 'echarts'
import MediumDialog from './medium.vue'
export default {
  components: {
    MediumDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sort: {
      type: number,
      default: 0
    },
    row: {
      type: Object,
      default: () => {}
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    partnerId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value(val) {
      console.log(val)
      console.log('watch-----------', this.row)

      if (this.row.id) {
        this.formData = {
          ...this.row,
          ...this.row.episodeMovie
        }
      } else {
        this.formData = {
          direction: 1,
          feeMode: 2
        }
      }
    }
  },
  computed: {
    rules() {
      const rules = {
        num: [{ required: true, message: '请输入分集序号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入分集名称', trigger: 'blur' }],
        playUrl: [
          { required: true, message: '请输入播放链接', trigger: 'blur' }
        ],
        feeMode: [
          { required: true, message: '请选择是否付费', trigger: 'change' }
        ],
        direction: [
          { required: true, message: '请选择视频样式', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择分集状态', trigger: 'change' }
        ]
      }
      /** 华视网聚播放链接不是必填的 */
      if (this.partnerId === 2) {
        delete rules.playUrl
      }
      return rules
    }
  },
  data() {
    return {
      selectedMedium: {
        name: '',
        playUrl: '',
        fileFormat: '',
        originDuration: ''
      },
      actionUrl:
        process.env.VUE_APP_BASE_URL +
        '/lebo-resource/oss/endpoint/put-file?code=lebotob', // 上传图片地址
      formData: {
        direction: 1,
        feeMode: 2
      },
      innerVisible: false,
      loading: false
    }
  },
  created() {
    if (this.row.id) {
      this.formData = {
        ...this.row,
        feeMode: this.row.episodeMovie ? this.row.episodeMovie.feeMode : 2,
        trialDuration: this.row.episodeMovie
          ? this.row.episodeMovie.trialDuration
          : ''
      }
    } else {
      this.formData = {
        direction: 1,
        feeMode: 2
      }
    }
  },
  methods: {
    // 选择介质回调
    mediumSelect(row) {
      this.selectedMedium = row
      this.formData.playUrl = row.playUrl
      this.formData.duration = row.originDuration
    },
    // 选择介质按钮
    choiceMedium() {
      this.$refs.medium.show()
    },
    // 预览img，video
    handleShowImage(url, type) {
      console.log('handleShowImage', url, type)
      // let _dom = type === 'video' ? type + ' controls' : 'img'
      // this.$alert(`<${_dom} src='` + url + "' style='width:100%'>", '图片/视频展示', {
      //   dangerouslyUseHTMLString: true,
      //   showConfirmButton: false,
      //   customClass: 'showImage',
      // });
      let _dom = 'video controls'
      this.$alert(
        `<${_dom} src='` + `${url}` + "' style='width:100%'>",
        '图片/视频展示',
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true,
          customClass: 'showImage',
          callback: () => {
            // 在弹窗关闭时执行停止视频播放的操作
            const videoElement = document.querySelector('.showImage video')
            if (videoElement) {
              videoElement.pause()
            }
          }
        }
      )
    },

    // 获取视频时长，单位秒
    analysisDuration() {
      if (!this.formData.playUrl) return
      let params = {
        videoUrl: this.formData.playUrl
      }
      this.loading = true
      analysisDurationApi(params).then((res) => {
        this.loading = false
        this.$set(this.formData, 'duration', res.data.data)
      })
    },

    // 保存
    mediaEpisodeSave() {
      let params = {
        sort: this.sort + 1,
        mediaId: this.$route.query.id,
        ...this.formData,
        episodeMovieCreateRequest: {
          episodeId: this.formData.episodeId,
          feeMode: this.formData.feeMode,
          releaseTime: this.formData.releaseTime,
          trialDuration: this.formData.trialDuration,
          vodDays: this.formData.vodDays
        }
      }
      let api = this.formData.id ? mediaEpisodeEditApi : mediaEpisodeApi

      this.$refs.formData.validate((valid) => {
        if (valid) {
          api(params).then((res) => {
            console.log('保存---->', res)
            if (res.data.code === 200) {
              this.closeDialog()
              this.$message.success('保存成功!')
            }
          })
        } else {
          return false
        }
      })
    },

    // 上传图片前校验
    beforeAvatarUpload(file) {
      console.log(file)
      // return true
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg' ||
        file.type === 'image/png'
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('只能上传jpg、jpeg或png格式的图片')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }

      return isJPG && isLt10M
    },
    // 上传图片后响应
    handleAvatarSuccess(res, key) {
      console.log(res)
      this.$set(this.formData, key, res.data.link)
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 关闭弹框
    closeDialog() {
      this.formData = {}
      this.value = false
      this.$emit('input', false)
    },
    handleClose(done) {
      this.closeDialog()
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>